import { render, staticRenderFns } from "./ThesisTeacher.vue?vue&type=template&id=548ebe1e"
import script from "./ThesisTeacher.vue?vue&type=script&lang=js"
export * from "./ThesisTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports